import { useCurrentUserContext } from '@openclassrooms/data-connect-web/users';

export default function useCanDisplayMerchandising(): boolean | undefined {
  const { isLoading, currentUser } = useCurrentUserContext();

  if (isLoading) {
    return undefined;
  }

  const canDisplay =
    !currentUser || (currentUser.enrollment === 'Free' && !currentUser.organization);

  return canDisplay;
}
